import { DEFAULT_DOMAIN } from './property-uri.constants';

export const AI_APP_ORIGIN = `https://omnicasa-ai.${DEFAULT_DOMAIN}`;

// WebAI (omnicasa-ai) job-tracking API, per the WebApp/WebAI integration
// contract. JOBS_STATUS (POST {ids: [job uuids]}) is the live-status feed
// for the WebApp-owned tracker; poll only while tracked jobs are active.
// Document AI (PDF) batches have their own status feed with the same
// request/response shape.
export const AI_JOB_TRACKER_URI = {
    JOBS_STATUS: `${AI_APP_ORIGIN}/api/image-generation/jobs/status`,
    JOBS_CANCEL: `${AI_APP_ORIGIN}/api/image-generation/jobs/cancel`,
    DOCUMENT_JOBS_STATUS: `${AI_APP_ORIGIN}/api/document-extraction/jobs/status`
};
